import { css } from '@emotion/react'
import styled from '@emotion/styled'
import {
  ArrowLeft,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
} from 'app/components/Icons'
import { theme } from 'app/theme/index'
import React, { memo } from 'react'

export interface Props {
  direction?: 'L' | 'R'
  disabled?: boolean
  onClick?: (e: any) => void
  variant?: Variant
}

export const Arrow = memo(function Arrow({
  direction = 'L',
  disabled,
  onClick,
  variant = 'default',
}: Props) {
  return (
    <Container
      className={disabled ? 'disabled' : undefined}
      onClick={onClick}
      variant={variant}
    >
      {variant === 'hero' ? (
        direction === 'L' ? (
          <ArrowLeft />
        ) : (
          <ArrowRight />
        )
      ) : direction === 'L' ? (
        <ChevronLeft />
      ) : (
        <ChevronRight />
      )}
    </Container>
  )
})

const Container = styled.div<ContainerProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.variants.neutralLight2};
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  position: relative;
  cursor: pointer;

  &:hover {
    svg {
      opacity: 0.4;
    }
  }

  &.disabled {
    display: none;
  }

  svg {
    height: 0.625rem;
    width: auto;
    fill: ${({ theme }) => theme.colors.variants.neutralDark1};
    transition: 0.4s cubic-bezier(0, 0.55, 0.45, 1);
  }

  @media (max-width: 1199px) {
    width: 3rem;
    height: 3rem;

    svg {
      height: 0.375rem;
      width: 1.5rem;
    }
  }

  ${({ variant }) => {
    switch (variant) {
      case 'invert':
        return css`
          background-color: ${theme.colors.variants.neutralDark2};

          svg {
            fill: ${theme.colors.variants.neutralLight3};
          }
        `
      case 'hero':
        return css`
          background: transparent;

          &:before {
            content: none;
          }

          svg {
            fill: ${theme.colors.variants.neutralLight3};
          }
        `
    }
  }}
`
interface ContainerProps {
  variant: Variant
}

export type Variant = 'default' | 'invert' | 'hero'
